/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const trackerTokens = {
  CoreBackgroundColorDefault: '#656b6b',
  CoreBackgroundColorHover: '#232b2b',
  CoreBackgroundColorActive: '#2c67b5',
  CoreBorderColorDefault: '#656b6b',
  CoreBorderColorDisabled: '#a7aaaa',
  CoreBorderColorHover: '#232b2b',
  CoreBorderColorActive: '#2c67b5',
  CoreBorderStyleComplete: 'solid',
  CoreBorderStyleDisabled: 'dotted',
  CoreBorderWidthPrimary: '1px',
  CoreBorderWidthSecondary: '2px',
  CoreFontSize: '14px',
  CoreFontWeight: '500',
  CoreFontLeading: '20px',
  CoreShadowFocus: '0 0 2px 4px #b5d1ea',
  CoreSpacing: '10px',
  CoreTextColorDefault: '#656b6b',
  CoreTextColorHover: '#232b2b',
  CoreTextColorActive: '#2c67b5',
  CoreTextColorComplete: '#656b6b',
  CoreTextColorDisabled: '#a7aaaa',
} as const;
